export default __webpack_public_path__ + "5e964f3eba7ae427ee639655ea167537.png";